import _ from "lodash";
import api from "../services/api";
import odataMixin from "@/core/store/mixin/odata";
import crudMixin from "@/core/store/mixin/crud";

const res = _.merge({}, odataMixin(api), crudMixin(api), {
  namespaced: true,
  actions: {
    getItems({ commit }, payload) {
      return api.getItems({ ...payload }).then((response) => ({
        items: response.data.items,
        totalCount: response.data.count,
      }));
    },
  },
});

export default res;
